module.exports = __webpack_public_path__ + "media/images/gift/gift-osusume-aa9b8390fcd3e5136b2017525e349d62.png";